import { Divider, Flex, HStack, Text, VStack } from '@chakra-ui/react';
import { ListingComparableSetFragment } from '@client/graphql/__generated__/types';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import {
  getCompsPriceRange,
  getMaxCompDistance,
} from '../../BuyerOfferAnalysis/Comps/utils';
import { NormalizedPropertyDetails } from '../../Listings/ListingPage/utils';

dayjs.extend(minMax);
export const CompsSummary = ({
  shortLabel = false,
  compact = false,
  listing,
  comparableSet,
}: {
  shortLabel?: boolean;
  compact?: boolean;
  listing?: NormalizedPropertyDetails;
  comparableSet?: ListingComparableSetFragment;
}) => {
  const numberOfComps = comparableSet?.listingComparables.length || 0;

  const hasAdjustments = comparableSet?.listingComparables.some(
    (comparable) => comparable?.adjustments?.priceAdjustment
  );

  const maxDistance = getMaxCompDistance(comparableSet, listing);

  const priceRange = getCompsPriceRange(comparableSet);

  const minDate = comparableSet?.listingComparables.reduce(
    (min, comparable) => {
      return dayjs.min(
        dayjs(min),
        dayjs(
          comparable.mlsListing.sales?.closeDate ||
            comparable.mlsListing.listDate ||
            ''
        )
      );
    },
    dayjs()
  );

  const maxDateDiff = dayjs().diff(minDate, 'days');

  if (compact) {
    return (
      <Flex direction="column">
        <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight="medium" mb={1}>
          {numberOfComps} Properties
        </Text>
        {numberOfComps > 0 && (
          <>
            <Text fontSize={{ base: 'sm', md: 'md' }}>{priceRange}</Text>
            <Text fontSize={{ base: 'sm', md: 'md' }}>
              {maxDateDiff} day oldest
            </Text>
            <Text fontSize={{ base: 'sm', md: 'md' }}>
              Within {maxDistance?.toFixed(1)} miles
            </Text>
          </>
        )}
      </Flex>
    );
  }

  return (
    <VStack gap={shortLabel ? 2 : 4} width="100%">
      <HStack justifyContent="space-between" width="100%">
        <Text fontWeight="medium">Number of Properties</Text>
        <Text>{numberOfComps}</Text>
      </HStack>
      <Divider />
      {numberOfComps > 0 && (
        <>
          <HStack justifyContent="space-between" width="100%">
            <Text fontWeight="medium">
              {shortLabel ? 'Range' : 'Comp Range'}
              {hasAdjustments && ' (Adjusted)'}
            </Text>
            <Text>{priceRange}</Text>
          </HStack>
          <Divider />
          <HStack justifyContent="space-between" width="100%">
            <Text fontWeight="medium">
              {shortLabel ? 'Distance' : 'Distance from subject property'}
            </Text>
            <Text>{maxDistance?.toFixed(1)} miles</Text>
          </HStack>
          <Divider />
          <HStack justifyContent="space-between" width="100%">
            <Text fontWeight="medium">
              {shortLabel ? 'Oldest' : 'Oldest comp'}
            </Text>
            <Text>{maxDateDiff} days</Text>
          </HStack>
          <Divider />
        </>
      )}
    </VStack>
  );
};
